<script lang="ts">
	import { Input, Text } from '@Shelly/shelly-design-system';
	import { format } from 'svelte-i18n';

	export let _id: string;
	export let labelKey: string;
	export let labelDefault: string;
	export let value: number;
	export let min: number;
	export let max: number;
	export let icon: string;
	export let validation: { error: string; info: string };
	export let onBlur: (e: Event) => void;
	export let onInput: (e: Event) => void;
	export let hintDefault = '';
	export let hintKey = '';
</script>

<div class="mb-s">
	<Text styleType="body-small" class="mb-xs">
		{$format(labelKey, { default: labelDefault })}
	</Text>
	<Input
		id={_id}
		size="m"
		{icon}
		value={String(value)}
		type="number"
		{min}
		{max}
		error={validation.error}
		info={validation.info}
		aria-label={$format(labelKey, { default: labelDefault })}
		on:input={onInput}
		on:blur={onBlur}
		on:change={onBlur}
	/>
	{#if hintKey}
		<Text styleType="tiny" class="text-color-muted mb-m">
			{$format(hintKey, { default: hintDefault })}
		</Text>
	{/if}
</div>
